import type { FeatureConfig } from '@skynet/feature-config';
import { RobotOutlined } from '@ant-design/icons';
import {
  BOT_COMMAND_DETAIL_ROUTE_PATH,
  BOT_COMMANDS_LIST_URL,
  BOT_COMMANDS_ROUTE_PATH,
} from './routes';

/**
 * Feature manifest for the Assistant Bot commands admin list and detail pages.
 * The dashboard shell reads this single source of truth instead of hardcoding
 * the route, navigation entry, header label and Cerbos action across its
 * routing, navigation, header and access-control modules.
 *
 * `route.load` and `detailRoute.load` are dynamic-import thunks, so importing
 * this config for its nav/header metadata never pulls the page implementations
 * into the main bundle.
 *
 * The route path, nav url and WS-login skip path come from this package's own
 * `./routes`, which also supplies the URLs the page hands to
 * `@skynet/sky-bot-commands`' components.
 *
 * `needsEntityId` is left at its default (`true`): the section also serves the
 * `/admin/bot-commands/:id` detail page.
 */
export const botCommandsConfig = {
  domain: 'Admin',
  section: 'bot-commands',
  route: {
    path: BOT_COMMANDS_ROUTE_PATH,
    load: async () => ({ default: (await import('./BotCommandsPage')).BotCommandsPage }),
  },
  detailRoute: {
    path: BOT_COMMAND_DETAIL_ROUTE_PATH,
    load: async () => ({ default: (await import('./BotPage')).BotPage }),
  },
  nav: {
    key: 'admin.bot-commands',
    label: 'Bot Commands',
    icon: <RobotOutlined />,
    url: BOT_COMMANDS_LIST_URL,
  },
  header: { label: 'Assistant Bot Commands' },
  cerbosAction: 'read:admin:bot-commands',
  skipWsLoginPaths: [BOT_COMMANDS_LIST_URL],
} as const satisfies FeatureConfig;
